export const API_BASE = "https://telugututorial.in/api";
